import { ref, computed } from 'vue';

// Module-level singletons so any component that imports this composable
// shares the same reactive state without a Pinia store.
const total = ref<number>(0);
const unassignedTotal = ref<number>(0);
const assignedAndArchivedTotal = computed(() => total.value - unassignedTotal.value);

export function useReferralAssignCounts() {
  return { total, unassignedTotal, assignedAndArchivedTotal };
}
